/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';
import { Line, Wrapper } from '../../common/Header';
export var Header = function Header() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null)), /*#__PURE__*/React.createElement(Line, null));
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1279",
    height: "56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1279v56H0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#HeaderA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M52 16h57v24H52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.172 20.6h2.124v10.498c0 2.768-1.263 4.7-4.194 4.7-1.102 0-1.963-.182-2.554-.39v-2.012c.645.261 1.425.392 2.204.392 1.802 0 2.42-1.045 2.42-2.56V20.6ZM87.195 19.79c.833 0 1.425.497 1.425 1.385 0 .862-.592 1.384-1.425 1.384-.834 0-1.425-.496-1.425-1.384 0-.862.591-1.384 1.425-1.384Zm-1.049 4.414h2.044v11.49h-2.044v-11.49ZM93.244 35.694h-1.99v-11.49h1.99v2.01c.7-1.357 1.882-2.323 4.195-2.193v1.933c-2.608-.261-4.195.496-4.195 2.95v6.79ZM106.983 33.631c-.752 1.515-2.177 2.298-4.006 2.298-3.145 0-4.732-2.585-4.732-5.98 0-3.238 1.667-5.98 4.974-5.98 1.721 0 3.065.757 3.764 2.246v-2.01h2.044v11.49h-2.044V33.63Zm-3.468.47c1.828 0 3.442-1.123 3.442-3.682v-.914c0-2.559-1.479-3.682-3.227-3.682-2.285 0-3.468 1.462-3.468 4.126.027 2.768 1.156 4.152 3.253 4.152Z",
    fill: "#253858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.498 18.25h-9.303c0 2.246 1.882 4.074 4.194 4.074h1.721v1.593c0 2.246 1.882 4.074 4.195 4.074v-8.958c0-.444-.35-.783-.807-.783Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9 22.742h-9.302c0 2.245 1.882 4.073 4.194 4.073h1.72v1.62c0 2.245 1.883 4.073 4.195 4.073v-8.983a.797.797 0 0 0-.807-.783Z",
    fill: "url(#HeaderB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.303 27.26H52c0 2.245 1.882 4.073 4.194 4.073h1.721v1.593c0 2.246 1.882 4.074 4.194 4.074v-8.957c0-.444-.376-.784-.806-.784Z",
    fill: "url(#HeaderC)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M133 0h86v56h-86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5 28a3 3 0 0 1 3-3h65a3 3 0 1 1 0 6h-65a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 54a1 1 0 0 1 1-1h76a1 1 0 0 1 1 1v2h-78v-2Z",
    fill: "#0052CC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M227 0h86v56h-86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "medium large",
    d: "M231 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: ".6",
    clipPath: "url(#HeaderD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M301 18h8v20h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "medium large",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z",
    fill: "#344563"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M321 0h86v56h-86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "medium large",
    d: "M325 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: ".6",
    clipPath: "url(#HeaderE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M395 18h8v20h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "medium large",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z",
    fill: "#344563"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M415 0h86v56h-86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "large",
    d: "M422.5 28a3 3 0 0 1 3-3h65a3 3 0 1 1 0 6h-65a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M509 0h86v56h-86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "large",
    d: "M513 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: ".6",
    clipPath: "url(#HeaderF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M583 18h8v20h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "large",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z",
    fill: "#344563"
  })), /*#__PURE__*/React.createElement("path", {
    className: "small",
    d: "M235 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
    fill: "#B3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "small",
    d: "M243 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "medium",
    d: "M423 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
    fill: "#B3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "medium",
    d: "M431 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "large",
    d: "M611 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
    fill: "#B3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "large",
    d: "M619 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M18 16h24v24H18z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z",
    fill: "#A5ADBA"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "HeaderA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(52 16)",
    d: "M0 0h57v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "HeaderD"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(301 18)",
    d: "M0 0h8v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "HeaderE"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(395 18)",
    d: "M0 0h8v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "HeaderF"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(583 18)",
    d: "M0 0h8v20H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HeaderB",
    x1: "66.509",
    y1: "22.764",
    x2: "62.673",
    y2: "26.838",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".176",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HeaderC",
    x1: "62.17",
    y1: "27.289",
    x2: "57.727",
    y2: "31.741",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".176",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  }))));
};